import React, { useEffect, useState } from "react";
import { loadModules } from "esri-loader";

const FormulaBuilder = () => {
    const [formula, setFormula] = useState('');
    const [regionalsGeo, setRegionalsGeo] = useState([]);

    const getRegionalPartnerGeo = async () => {

        try {
            const [Query, query] = await loadModules(["esri/rest/support/Query", "esri/rest/query"]);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/IWW_parameters/FeatureServer/3";

            // create the Query object
            let queryObject = new Query();
            queryObject.where = "1=1";
            queryObject.returnGeometry = true;
            queryObject.outFields = "*";

            const results = await query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setRegionalsGeo(results.features);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    useEffect(() => {
        getRegionalPartnerGeo();
    }, []);

    const handleFormulaChange = (e) => {
        setFormula(e.target.value);
    };

    const addToFormula = (input) => {
        setFormula((prevFormula) => `${prevFormula} ${input}`);
    }

    const clearFormula = () => {
        setFormula('');
    };

    const validateFormula = () => {
        try {
            const substitutedFormula = substituteFieldsInFormula(formula);
            const result = eval(substitutedFormula);
            alert(`Formula is valid and evaluates to: ${result}`);
        } catch (error) {
            alert('Formula is invalid');
        }
    };

    const substituteFieldsInFormula = (formula) => {
        let substitutedFormula = formula;
        if (regionalsGeo.length > 0) {
            const attributes = regionalsGeo[0].attributes;
            for (const field in attributes) {
                if (attributes.hasOwnProperty(field)) {
                    substitutedFormula = substitutedFormula.replace(new RegExp(field, 'g'), attributes[field]);
                }
            }
        }
        substitutedFormula = substitutedFormula.replace(/randomstring/g, `'${generateRandomString()}'`);
        substitutedFormula = substitutedFormula.replace(/now/g, `'${new Date().toISOString()}'`);
        return substitutedFormula;
    };

    const generateRandomString = () => {
        return Math.random().toString(36).substring(2, 15);
    };

    const days = (n) => {
        return n * 24 * 60 * 60 * 1000;
    };

    const months = (n) => {
        return n * 30 * 24 * 60 * 60 * 1000;
    };

    const years = (n) => {
        return n * 365 * 24 * 60 * 60 * 1000;
    };

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', backgroundColor: '#E0F0F0', borderRadius: '10px' }}>
            {/* <h2>Formula Builder</h2>
            <div style={{ display: 'flex' }}>
                <textarea
                    value={formula}
                    onChange={handleFormulaChange}
                    style={{ width: '60%', height: '300px', marginRight: '20px', padding: '10px' }}
                />
                <div style={{ width: '40%' }}>
                    <div style={{ marginBottom: '10px' }}>
                        <label>Fields/Tokens:</label>
                        <select onChange={(e) => addToFormula(e.target.value)} style={{ width: '100%', padding: '10px' }}>
                            <option value="">select a field</option>
                            {regionalsGeo.length > 0 && Object.keys(regionalsGeo[0].attributes).map((attr, index) => (
                                <option key={index} value={attr}>{attr}</option>
                            ))}
                        </select>
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <label>Operators:</label>
                        <div>
                            {['+', '-', '*', '/', '%', '<', '>', '>=', '<=', '!=', '==', '&&', '||'].map(op => (
                                <button key={op} onClick={() => addToFormula(op)} style={{ padding: '10px', margin: '2px' }}>{op}</button>
                            ))}
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <label>Keywords:</label>
                        <div>
                            {['randomstring', 'now', 'days', 'months', 'years'].map(keyword => (
                                <button key={keyword} onClick={() => addToFormula(keyword + '()')} style={{ padding: '10px', margin: '2px' }}>{keyword}</button>
                            ))}
                        </div>
                    </div>
                    {/* <div style={{ marginBottom: '10px' }}>
                        <label>Functions:</label>
                        <select onChange={(e) => addToFormula(e.target.value)} style={{ width: '100%', padding: '10px' }}>
                            <option value="">select a function</option>
                            <option value="func1()">func1</option>
                            <option value="func2()">func2</option>
                        </select>
                    </div> 
                </div>
            </div>
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
                <button onClick={validateFormula} style={{ padding: '10px 20px', backgroundColor: 'green', color: 'white' }}>Validate</button>
                <button onClick={clearFormula} style={{ padding: '10px 20px', backgroundColor: 'red', color: 'white' }}>Clear</button>
                <button onClick={() => alert('Formula confirmed')} style={{ padding: '10px 20px', backgroundColor: 'blue', color: 'white' }}>OK</button>
                <button onClick={() => alert('Cancelled')} style={{ padding: '10px 20px', backgroundColor: 'grey', color: 'white' }}>Cancel</button>
            </div>
*/}
            <h1>Regional Partner Geo</h1>
            <pre>{JSON.stringify(regionalsGeo, null, 2)}</pre>
        </div>
    );
};

export default FormulaBuilder;